import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import NavBar from '../../../NavBar';
import B2BHeader from './B2BHeader';
import B2BFooter from './B2BFooter';

function scrollToHash(hash) {
  const id = hash.replace('#', '');
  if (!id) return false;

  const el = document.getElementById(id);
  if (!el) return false;

  // Offset for sticky purple bar + header
  const headerOffset = 110;
  const top = el.getBoundingClientRect().top + window.pageYOffset - headerOffset;
  window.scrollTo({ top, behavior: 'smooth' });
  return true;
}

export default function B2BLayout({ children }) {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      window.scrollTo(0, 0);
      return;
    }

    // Wait for the destination page to mount before scrolling
    let attempts = 0;
    const tryScroll = () => {
      if (scrollToHash(hash) || attempts >= 20) return;
      attempts += 1;
      window.setTimeout(tryScroll, 50);
    };

    const timer = window.setTimeout(tryScroll, 0);
    return () => window.clearTimeout(timer);
  }, [pathname, hash]);

  return (
    <div className="b2b-root min-h-screen bg-paper flex flex-col" style={{ fontFamily: "'Public Sans', sans-serif" }}>
      <NavBar showMainNav={false} />
      <B2BHeader />
      <main id="main-content" className="flex-grow" style={{ marginTop: '30px' }}>
        {children}
      </main>
      <B2BFooter />
    </div>
  );
}
